export default "__VITE_ASSET__BVnjUhIT__"